import React, { useEffect, useState } from 'react';
import '../../urunDiv.css';
import '../icecekler/sicak-kahveler/KahveDetay.css';
import atistirmalik from '../../../assets/menu/sandivic-3.png';

const SosisBasket = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsPhone(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const yemek = {
    name: 'Sosis Basket',
    price: '₺499,90',
    image: atistirmalik,
    description: 'Ürün fotoğrafı, fiyatı ve içerik bilgisi eklenecek.'
  };

  return isPhone ? (
    <div className="americano-detay-container">
      <div className="product-section">
        <div className="product-image-container">
          <img src={yemek.image} alt={yemek.name} className="product-image" />
          <div className="product-overlay">
            <div className="product-name-price">{yemek.name} - {yemek.price}</div>
          </div>
        </div>
        <div className="product-description">
          <p>{yemek.description}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className="urun-detay-container-computer">
      <div className="product-section">
        <div className="product-image-container">
          <img src={yemek.image} alt={yemek.name} className="product-image" />
          <div className="product-overlay">
            <div className="product-name-price">{yemek.name} - {yemek.price}</div>
          </div>
        </div>
        <div className="product-description-computer">
          <p>{yemek.description}</p>
        </div>
      </div>
    </div>
  );
};

export default SosisBasket;
